import { Box, Dialog, DialogTitle, Typography } from "@mui/material"
import React, { SetStateAction } from "react"
import { customPalette } from "../../../theme"
import { SupportForm } from "../../core/dto/support/support-form"
import { useUser } from "../../core/hooks/use-user"
import { SupportFormComponent } from "../forms/support-form-component"

type IProps = {
  open: boolean
  setOpenContactForm: React.Dispatch<SetStateAction<boolean>>
}

export function SupportContactDialog({ open, setOpenContactForm }: Readonly<IProps>): React.JSX.Element {
  const { sendSupportForm } = useUser()

  function handleClose(): void {
    setOpenContactForm(false)
  }

  function sendMessageToSupportTeam(supportForm: SupportForm): Promise<void> {
    return sendSupportForm(supportForm)
      .then(() => {
        setOpenContactForm(false)
      })
      .catch((error: any) => {
        console.error("Issue with supportForm :", error)
      })
  }

  return (
    <Box>
      <Dialog maxWidth="lg" open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: customPalette.white }}>
          <Typography fontSize={24} fontWeight={600}>
            Contacter le support
          </Typography>
        </DialogTitle>
        <SupportFormComponent onSubmit={sendMessageToSupportTeam} handleClose={handleClose} />
      </Dialog>
    </Box>
  )
}
